/* Quick Select popover on PLP product cards.
   Clicking "Select options" (a .m-product-quickview-button with [data-quick-select])
   opens a compact variant picker anchored to the card. Selecting a variant and
   clicking "Add to cart" posts to /cart/add.js and opens the cart drawer. */
(function () {
  function popoverFor(trigger) {
    // Same product can appear in several cards/carousels, so resolve the
    // popover inside the trigger's own card first instead of returning the
    // first matching handle on the page.
    var card = trigger.closest('.m-product-card');
    if (card) {
      var scoped = card.querySelector('.m-quick-select[data-quick-select-popover]');
      if (scoped) return scoped;
    }
    var handle = trigger.getAttribute('data-product-handle');
    return document.querySelector('.m-quick-select[data-quick-select-popover][data-product-handle="' + handle + '"]');
  }

  function variantsFor(popover) {
    var node = popover.querySelector('[data-quick-select-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (e) { return []; }
  }

  function selectedValues(popover) {
    var values = {};
    popover.querySelectorAll('.m-quick-select__option').forEach(function (group) {
      var pos = group.getAttribute('data-option-position');
      var sel = group.querySelector('.m-quick-select__value.is-selected');
      if (sel) values[pos] = sel.getAttribute('data-value');
    });
    return values;
  }

  function findVariant(popover, variants) {
    var selected = selectedValues(popover);
    var positions = Object.keys(selected);
    if (!positions.length) return null;
    // Every option group must have a selection before a variant is resolvable.
    var groups = popover.querySelectorAll('.m-quick-select__option');
    if (groups.length !== positions.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < positions.length; j++) {
        var idx = parseInt(positions[j], 10) - 1;
        if (v.options[idx] !== selected[positions[j]]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function refreshAddState(popover) {
    var variants = variantsFor(popover);
    var variant = findVariant(popover, variants);
    var addBtn = popover.querySelector('[data-quick-select-add]');
    if (!addBtn) return;
    if (variant && variant.available) {
      addBtn.disabled = false;
      addBtn.setAttribute('data-variant-id', variant.id);
    } else {
      addBtn.disabled = true;
      addBtn.removeAttribute('data-variant-id');
    }
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  // Put a portaled popover back where it was rendered (inside its card).
  function restorePopover(popover) {
    if (popover._qsHome && popover.parentNode !== popover._qsHome) {
      popover._qsHome.appendChild(popover);
    }
  }

  function hidePopover(popover) {
    if (!popover) return;
    popover.hidden = true;
    restorePopover(popover);
  }

  function openPopover(popover) {
    if (!popover) return;
    document.querySelectorAll('.m-quick-select[data-quick-select-popover]:not([hidden])').forEach(function (p) {
      if (p !== popover) hidePopover(p);
    });
    // On mobile the popover is a fixed overlay. Move it out of any transformed
    // ancestor (e.g. homepage carousels) so position:fixed resolves to the
    // viewport instead of that ancestor, then move it back when closed.
    if (isMobile()) {
      if (!popover._qsHome) popover._qsHome = popover.parentNode;
      if (popover.parentNode !== document.body) document.body.appendChild(popover);
    }
    popover.hidden = false;
    refreshAddState(popover);
  }

  function closePopover(popover) {
    hidePopover(popover);
  }

  function addToCart(popover) {
    var addBtn = popover.querySelector('[data-quick-select-add]');
    var variantId = addBtn && addBtn.getAttribute('data-variant-id');
    if (!variantId) return;
    addBtn.classList.add('m-spinner-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function (cartResponse) {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, cartResponse);
        var d = document.querySelector('m-cart-drawer');
        if (d) {
          // Render the drawer contents directly from the add-to-cart response
          // (avoids a separate /cart fetch that can 401 in dev and ensures the
          // line item quantity updates when the same variant is added again).
          if (typeof d.renderContents === 'function' && cartResponse.sections) {
            d.renderContents(cartResponse);
          } else if (typeof d.open === 'function') {
            d.open();
          }
        }
      } else {
        window.location.href = '/cart';
      }
      closePopover(popover);
    }).catch(function (err) {
      console.error('[quick-select] add to cart failed', err);
    }).then(function () {
      addBtn.classList.remove('m-spinner-loading');
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-select]');
    if (trigger) {
      e.preventDefault();
      var popover = popoverFor(trigger);
      if (popover) {
        if (popover.hidden) openPopover(popover);
        else closePopover(popover);
      }
      return;
    }

    var valueBtn = e.target.closest('.m-quick-select__value');
    if (valueBtn && !valueBtn.disabled) {
      var group = valueBtn.closest('.m-quick-select__option');
      group.querySelectorAll('.m-quick-select__value').forEach(function (b) {
        b.classList.remove('is-selected');
        b.removeAttribute('data-selected');
      });
      valueBtn.classList.add('is-selected');
      valueBtn.setAttribute('data-selected', 'true');
      refreshAddState(valueBtn.closest('.m-quick-select[data-quick-select-popover]'));
      return;
    }

    var addBtn = e.target.closest('[data-quick-select-add]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      addToCart(addBtn.closest('.m-quick-select[data-quick-select-popover]'));
      return;
    }

    var closeBtn = e.target.closest('[data-quick-select-close]');
    if (closeBtn) {
      closePopover(closeBtn.closest('.m-quick-select[data-quick-select-popover]'));
      return;
    }

    // Click outside the popover panel (incl. its backdrop) closes it.
    if (!e.target.closest('.m-quick-select__panel')) {
      document.querySelectorAll('.m-quick-select[data-quick-select-popover]:not([hidden])').forEach(hidePopover);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.m-quick-select[data-quick-select-popover]:not([hidden])').forEach(hidePopover);
    }
  });
})();
